import { createTempDashboard } from '@src/store/tempDashboard/actions';
import { setSelectedAiAlert } from '@src/store/trends/aiAlerts/actions';
import { DASHBOARD_TYPE } from '@src/utils/constants';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useFetchDiagnostics from './useFetchDiagnostics';

export const useCreateTempAlertDashboard = ({ alertType, alertId }) => {
  const dispatch = useDispatch();
  const { data, isFetching } = useFetchDiagnostics({ alertType, alertId });

  useEffect(() => {
    if (!alertId || isFetching) {
      return;
    }

    dispatch(setSelectedAiAlert({ selectedAlertId: alertId, selectedAlertType: alertType }));
    const dashboard = {
      'module:trends': {
        aiAlerts: {
          selectedAlertId: alertId,
          selectedAlertType: alertType,
        },
      },
      'module:aiAlerts': {
        selectedAiAlertDiagnostics: data,
      },
    };
    const { summary } = data;

    dispatch(setSelectedAiAlert({ selectedAlertMetric: summary.metricName }));
    const { rootCauseDisplayLabel } = summary;
    const rootCauseParam = rootCauseDisplayLabel.replaceAll('&&&', ' and ');

    dispatch(
      createTempDashboard(
        DASHBOARD_TYPE.AI_ALERT_DIAGNOSTICS,
        dashboard,
        `Alert- ${rootCauseParam}`,
      ),
    );
  }, [alertId, isFetching]);

  return { isFetching };
};
